<template>
  <div v-if="is_load">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>
        <li class="breadcrumb-item"><a href="/shop">На продажу</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ category.title}}</li>
      </ol>
    </nav>
    <section class="section section section-shaped my-0 overflow-hidden content_background_color_blue2">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <div class="d-flex px-3">
            <div>
              <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                    rounded></icon>
            </div>
            <div class="pl-4">
              <h4 class="display-3 text-white">На продажу</h4>
              <p class="text-white">Тут собраны все готовые системы, разработанные мной.</p>
              <p class="text-white"><a href="#" target="_blank" class="text-white">Отзывы</a></p>

            </div>
          </div>

          <div class="row col-md-12 mt-3" v-if="items.length>0">
            <router-link v-for="item in items" :key="item.last_id"
                         v-if="items.length>0"
                         :to="{name: 'shop_item_id', params: { id: item.last_id }}">
              <sui-card class="col-md-3 m-2">
                <a href="#">

                  <sui-image :src="item.photos[0]"/>
                </a>
                <sui-card-content>
                  <sui-card-header><a>{{ item.title }}</a></sui-card-header>
                  <sui-card-meta>

                    <a>Подробнее</a>

                  </sui-card-meta>
                </sui-card-content>
              </sui-card>
            </router-link>


          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";




var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {},
  data() {
    return {
      "category":null,
      "items":[],
      "is_load":false,
    }
  },
  mounted() {
    var category_id=this.$route.params.id;

    var app=this;
    Api.loadItemsCategory(category_id,function(data){


      app.category=data.category;
      app.items=data.items;
      app.is_load=true;
    })
  },
  methods: {





  }
};
</script>
